export default __webpack_public_path__ + "scroll.64b1706791c749ad17c0.svg";